import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiPenTool, FiLayout, FiFilm, FiImage, FiCheckCircle } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import brandingHero from "../assets/branding-hero.jpg";

const services = [
  { icon: FiPenTool, title: "Brand Identity Design", desc: "Logo design, brand guidelines, color palettes, typography, and complete visual identity systems." },
  { icon: FiLayout, title: "UI/UX Design", desc: "User research, wireframing, prototyping, and pixel-perfect interface design for web and mobile." },
  { icon: FiFilm, title: "Motion Graphics & Video", desc: "Animated explainers, social media videos, product demos, and brand storytelling content." },
  { icon: FiImage, title: "Creative Assets", desc: "Social media creatives, banners, presentations, infographics, and marketing collateral." },
];

const BrandingCreative = () => {
  return (
    <>
      <HeroBanner
        image={brandingHero}
        title="Branding & Creative Solutions"
        subtitle="Brand identity, UI/UX design, motion graphics, and creative assets that convert attention into action."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">Creative <span className="text-primary">Services</span></h2>
          <p className="section-subtitle mx-auto">Build a powerful brand that stands out and drives engagement.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="card-hover flex gap-5">
              <s.icon className="w-12 h-12 text-primary flex-shrink-0" />
              <div>
                <h3 className="font-montserrat font-bold text-xl mb-2">{s.title}</h3>
                <p className="text-muted-foreground font-roboto text-sm leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Let's Create Something Amazing</h2>
        <Link to="/contact" className="btn-hero-outline">Start Your Brand</Link>
      </SectionWrapper>
    </>
  );
};

export default BrandingCreative;
